import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Flag from 'react-flagkit';
import { formatMoney } from 'accounting-js';

import ProductPropertyTab from '../../molecules/product-detail-accordion';
import Typography from '../../atoms/typography';
import Radio from '../../atoms/radio';

const VendorList = styled.ul`
  color: ${({ theme }) => theme.color.brand};
  padding-bottom: 1rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.color.brandLight};
`;

const HowItWorks = styled(Typography)`
  letter-spacing: 0.2em;
  text-transform: uppercase;
  line-height: 3rem;
`;

const Country = styled(Flag)`
  margin-left: 1rem;
  width: 2rem;
  font-size: 1.5rem;
`;

const Vendor = styled.p`
  margin-left: auto;

  ~ ${Country} {
    height: 3.5rem;
  }
`;

const Variant = styled(Radio)`
  display: flex;

  ${Country} {
    margin: 0 1rem 0 0;
    height: 1.8rem;
  }

  > span {
    margin-left: auto;
  }
`;

const ShippingFrom = (props) => {
  const getVendorPrice = (vendor) => {
    const price = props.variant.prices.find((v) => v.vendor_id === vendor.vendor_id);
    return price ? price.price : 0;
  };

  const getVendor = (id) => props.variant.stock_items.find((v) => v.vendor_id === id);

  if (!props.vendor || !props.variant) return null;

  return (
    <ProductPropertyTab
      title="Shipping From"
      product={props.product}
      subtitle={(
        <>
          <Vendor>{getVendor(props.vendor).stock_location_name}</Vendor>
          <Country country={getVendor(props.vendor).country_iso} />
        </>
      )}
    >
      <VendorList>
        {
          props.variant.stock_items
            .filter((stock) => stock.available)
            .map((vendor) => (
              <Variant
                key={vendor.id}
                active={props.vendor === vendor.vendor_id}
                id={`vendor-${vendor.vendor_id}`}
                name={`vendor-${vendor.vendor_id}`}
                changed={() => props.onVendorChange(vendor.vendor_id)}
              >
                <Country country={vendor.country_iso} />
                {vendor.stock_location_name}
                <span>{formatMoney(getVendorPrice(vendor))}</span>
              </Variant>
            ))
        }
      </VendorList>

      <HowItWorks element="p" like="label-1">How It Works: </HowItWorks>
      <Typography element="p" like="paragraph-2">
          We partner with the best boutiques from around the world,
          which means many of those boutiques might carry the same product.
          So we’ve automatically picked the lowest price based on your location,
          but feel free to change the selection above.
      </Typography>
    </ProductPropertyTab>
  );
};

ShippingFrom.defaultProps = {
  variant: null,
  vendor: null
};

ShippingFrom.propTypes = {
  product: PropTypes.object.isRequired,
  variant: PropTypes.object,
  vendor: PropTypes.number,
  onVendorChange: PropTypes.func.isRequired
};

export default ShippingFrom;
